//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start

import { OPTION_CHAIN } from '../actionTypes';


const initialState = {
    arrOptionData: [],
    arrDistinctDates: [],
    arrGlobalSearchOptionChainData: [],
    arrGlobalSearchFutOptions: [],
    objScripData: {},
    arrSelectedRows: [],
    bCheckboxes: false,
    objOptDataWrtExp: {},
    selectedDate: null,
    objSelectedTabs: {},
    objMultiLeg: {},
    optionChainPopover: false,
    objScripsRequested: {},
    // after this line every variable is for new optionchain
    arrDistinctDatesForOptionChain: [],
    optionChainDummyData: [],
    isToggle: false,
    arrStrikePrices: [],
    objOptionChainPayload: {},
    isLoadingOptionChian: true,
    objMultiLegData: {},
    arrLegDataForOptionChain: [],
    objLegDataForOptionChain: {},
    objOptionChainLastStack: {},
    isSideOptionChainSticked: false
};




const optionChainReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case OPTION_CHAIN?.IS_SIDE_OPTION_CHAIN_STICKED:
            return {
                ...state,
                isSideOptionChainSticked: actions?.payload
            };
        case OPTION_CHAIN?.OPTION_CHAIN_LAST_STACK:
            return {
                ...state,
                objOptionChainLastStack: actions?.payload
            };
        case OPTION_CHAIN.LEG_DATA_FOR_OPTION_CHAIN:
            return {
                ...state,
                arrLegDataForOptionChain: actions?.payload
            };
        case OPTION_CHAIN?.UPDATE_OBJ_MULTILEG_DATA:
            return {
                ...state,
                objMultiLegData: actions?.payload
            };
        case OPTION_CHAIN?.CLEAR_OPTION_CHAIN_DATA:
            return {
                ...state,
                arrDistinctDatesForOptionChain: [],
                optionChainDummyData: [],
                arrStrikePrices: [],
                objOptionChainPayload: {},
                isLoadingOptionChian: true
            };
        case OPTION_CHAIN?.UPDATE_OPTION_CHAIN_LOADING:
            return {
                ...state,
                isLoadingOptionChian: actions?.payload
            };
        case OPTION_CHAIN?.UPDATE_OPTION_CHAIN_PAYLOAD:
            return {
                ...state,
                objOptionChainPayload: actions?.payload
            };
        case OPTION_CHAIN.UPDATE_OPTION_CHAIN_ARR_STRIKE_PRICES:
            return {
                ...state,
                arrStrikePrices: actions?.payload
            };
        case OPTION_CHAIN?.OPTION_CHAIN_TOGGLE_CHECKBOX:
            return {
                ...state,
                isToggle: actions?.payload
            };
        case OPTION_CHAIN?.OPTION_CHAIN_DUMMY_DATA:
            return {
                ...state,
                optionChainDummyData: actions?.payload
            };
        case OPTION_CHAIN.UPDATE_VISIBLESCRIPS_FOR_OPTION_CHAIN:
            return {
                ...state,
                objScripsRequested: actions?.payload
            };
        case OPTION_CHAIN.OPTION_CHAIN_POPOVER_UPDATE:
            return {
                ...state,
                optionChainPopover: actions?.payload
            };
        case OPTION_CHAIN.GLOBAL_SEARCH_FUT_OPTION_SCRIPS:
            return {
                ...state,
                arrGlobalSearchFutOptions: actions?.payload
            };
        case OPTION_CHAIN.GLOBAL_SEARCH_ONLY_OPTION_CHAIN_DATA:
            return {
                ...state,
                arrGlobalSearchOptionChainData: actions?.payload
            };
        case OPTION_CHAIN.SAVE_OPTION_DATA:
            return {
                ...state,
                arrOptionData: actions.payload
            };
        case OPTION_CHAIN.SAVE_DISTINCT_DATES:
            return {
                ...state,
                arrDistinctDates: actions.payload
            };
        case OPTION_CHAIN.SAVE_DISTINCT_DATES_OPTIONS:
            return {
                ...state,
                arrDistinctDatesForOptionChain: actions?.payload
            };
        case OPTION_CHAIN.SCRIP_DATA:
            return {
                ...state,
                objScripData: actions.payload
            };
        case OPTION_CHAIN.SELECTED_ROWS:
            return {
                ...state,
                arrSelectedRows: actions.payload
            };
        case OPTION_CHAIN.bCheckboxes:
            return {
                ...state,
                bCheckboxes: actions.payload
            };
        case OPTION_CHAIN.OPTION_DATA_WRT_EXPIRY:
            return {
                ...state,
                objOptDataWrtExp: actions.payload
            };
        case OPTION_CHAIN.SELECTED_DATE:
            return {
                ...state,
                selectedDate: actions.payload
            };
        case OPTION_CHAIN.SELECTED_TAB:
            return {
                ...state,
                objSelectedTabs: actions.payload
            };
        case OPTION_CHAIN.MULTI_LEG_DATA:
            return {
                ...state,
                objMultiLeg: actions.payload
            };
        default:
            return state;
    }

};

export default optionChainReducer;

